@if (team) {
    <panel width="400">
        <h1>{{ (teamId ? 'general.edit' : 'general.add') | translate }}</h1>
        <section>
            <custom-input [label]="'team.name' | translate" [(value)]="team.name" [required]="true" />
            <custom-input [inputType]="inputType.Switch" [label]="'team.sale' | translate" [(value)]="team.sale" />
            @if (team.sale) {
                <custom-select [label]="'team.brand' | translate"
                           [selectList]="brands"
                           [(value)]="team.salesBrandId"
                           [required]="true"></custom-select>
            }
        </section>
        <h2>{{ 'team.users' | translate }}</h2>
        <list-view scrollable [selectable]="false">
            <header defaultSort="descending"></header>
            <header>{{ 'general.name' | translate }}</header>
            <row *listData="let user from users" (action)="user.selected = !user.selected">
                <column [sortValue]="user.wasSelected"><input type="checkbox" [(checked)]="user.selected" /></column>
                <column>{{ user.name }}</column>
            </row>
        </list-view>
        <section>
            <button #saveButton [active]="canSave()" (click)="save()">{{ 'general.save' | translate }}</button>
        </section>
    </panel>
}
@if (team && team.id) {
    <view-team-credentials [teamId]="team.id" />
}
